import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { __API_URL__ } from "../SERVER_URL";
import { showApiErrorToast } from "../utils/helpers";

const updateEdiaryStartDate = async ({ patientId, trialId, startDate }) => {
  const token = localStorage.getItem("token");

  const res = await axios.patch(
    `${__API_URL__}/api/photos/ediary/start-date/${patientId}/`,
    { trial_id: trialId, start_date: startDate },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateEdiaryStartDateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateEdiaryStartDate,
    onSuccess: (_, variables) => {
      toast.success("eDiary start date updated");
      queryClient.invalidateQueries({
        queryKey: ["patient_ediary", variables.patientId],
      });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update the eDiary start date");
    },
  });
};

export default useUpdateEdiaryStartDateMutation;
